import React, { FunctionComponent } from "react";
import { Chip, createStyles, Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { UserOrderState as State } from "../../../models/User";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    ordered: {
      color: "grey",
      borderColor: "grey"
    },
    processing: {
      color: "orange",
      borderColor: "orange"
    },
    awaitingPickup: {
      color: "green",
      borderColor: "green"
    }
  })
);

interface UserOrderStateProps {
  state: State;
}

export const UserOrderState: FunctionComponent<UserOrderStateProps> = ({
  state
}) => {
  const classes = useStyles();
  return (
    <Chip
      size="small"
      variant={"outlined"}
      label={state}
      className={
        state === State.Ordered
          ? classes.ordered
          : state === State.Processing
          ? classes.processing
          : classes.awaitingPickup
      }
    />
  );
};
